// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d4804898","453":"045f7c2f","732":"0d1f1c76"}[chunkId] + ".chunk.js";
};